import { BaseViewStore } from 'core/stores';
import { makeObservable, observable } from 'mobx';
import _ from 'lodash';


class CancelUncancelResultViewStore extends BaseViewStore {
	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
        this.data = modalParams && modalParams.data ? modalParams.data : null;
	}
}

export default CancelUncancelResultViewStore;
